import { createSlice } from '@reduxjs/toolkit';
import { ResponseApi } from '../BaseApi';

const documentPanelSlice = createSlice({
    name: 'documentPanel',
    initialState: {
        deleteDocumentById: {},
        getAllDepartments: [],
        createEmployeeDoc: {},
        createContractorDoc: {},
    },
    reducers: {},
    extraReducers: {
        'documentPanel/deleteDocumentById/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.deleteDocumentById = data;
            } else if (status >= 400 && status < 500) {
            }
        },
        'documentPanel/getAllDepartments/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getAllDepartments = data?.data;
            } else if (status >= 400 && status < 500) {
            }
        },
        'documentPanel/createEmployeeDoc/fulfilled': (state, action) => {
            state.createEmployeeDoc = ResponseApi(action.payload);
        },
        'documentPanel/createContractorDoc/fulfilled': (state, action) => {
            state.createContractorDoc = ResponseApi(action.payload);
        },
        'documentPanel/deleteAllVehicleDocument/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.deleteAllVehicleDocument = data;
            } else if (status >= 400 && status < 500) {
            }
        },
    },
});

export const {} = documentPanelSlice.actions;

export default documentPanelSlice.reducer;
